import { makeStyles, Theme } from '@material-ui/core';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { ExportButton } from '../../../comps/ExportButton';
import { ImportButton } from '../../../comps/ImportButton';
import { OcDataview } from '../../../comps/OcDataview';
import { OcDataviewFiltering } from '../../../comps/OcDataviewFiltering';
import { Submenu } from '../../../comps/Submenu';
import { useNoSubmenu } from '../../../mainpanel/useSubmenu';
import { DataviewStore } from '../../../stores/DataviewStore';
import { useOmnistore } from '../../../stores/Omnistore';
import { EditOutletDialog } from './EditOutletDialog';

const useStyles = makeStyles((theme: Theme) => ({
	OutletPage: {
		display: 'grid',
		gridTemplateRows: 'auto 1fr',
		flex: 1,
	},
}));

const dataviewStore = DataviewStore.create({
	id: 'OutletPage',
	orgColumns: [
		'name',
		'ownerEmail',
		'zipcode 50',
		'categories',
		'facebookUrl',
		'homepageUrl',
		'id 50',
	],
	filtering: [
		{columns: ['name']},
		{columns: ['ownerEmail']},
		{columns: ['zipcode']},
		{columns: ['categories']},
	],
	sorting: {column: 'name'},
});
dataviewStore.addColumnHiderToNamed('DEFAULT', 'id');

export const OutletPage = observer(function OutletPage() {
	const classes = useStyles();
	const omnistore = useOmnistore();
	const multirepo = omnistore.multirepo;
	const outletRepo = multirepo.outletRepo;
	const idsString = dataviewStore.applyTo(outletRepo.allAsList).map(e => e.id).join(' ');
	const outlet = outletRepo.byId(dataviewStore.selectedEntityId);

	useNoSubmenu();
	useEffect(() => void outletRepo.fetch(), []);

	return <div className={classes.OutletPage}>
		<Submenu>
			<OcDataviewFiltering state={dataviewStore} repo={outletRepo}/>
			---
			<ExportButton path="OutletExport.xlsx" params={{idsString}}/>
			<ImportButton path="OutletImport" afterImport={() => outletRepo.fetch('DIRECT')}/>
		</Submenu>
		<OcDataview state={dataviewStore} repo={outletRepo}/>
		{!outlet ? null : <EditOutletDialog onClose={() => dataviewStore.rowClick(0)} outlet={outlet}/>}
	</div>;
});
